/* Evoluzione Imprese — Backstage: consumer contenuti Google Drive.
   Popola ogni contenitore [data-ei-drive] con i file/cartelle del cliente,
   letti da <apiBase>/.netlify/functions/backstage-drive.
   Config passata dal tema in window.EI_BACKSTAGE_DRIVE:
     { apiBase, clientKey, email }  */
(function () {
  'use strict';

  var CFG = window.EI_BACKSTAGE_DRIVE || {};
  var API = (CFG.apiBase || '').replace(/\/+$/, '');
  var CLIENT = CFG.clientKey || '';
  var EMAIL = CFG.email || '';

  var ICON_FOLDER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17L17 7"/><polyline points="7 7 17 7 17 17"/></svg>';

  function driveIcon(mime, isFolder) {
    if (isFolder) return ICON_FOLDER;
    var m = mime || '';
    var color = '#6b6b6b';
    if (m.indexOf('spreadsheet') > -1) color = '#0f9d58';
    else if (m.indexOf('document') > -1) color = '#4285f4';
    else if (m.indexOf('presentation') > -1) color = '#f4b400';
    else if (m.indexOf('pdf') > -1) color = '#dc2626';
    else if (m.indexOf('video') > -1) color = '#dc2626';
    else if (m.indexOf('image') > -1) color = '#1e3494';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>';
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function state(box, cls, html) {
    box.innerHTML = '';
    box.appendChild(el('div', 'ei-bs-dl__state ' + cls, html));
  }

  function skeleton(box) {
    box.innerHTML = '';
    for (var i = 0; i < 3; i++) box.appendChild(el('div', 'ei-bs-dl__skel'));
  }

  function render(box, data) {
    var files = (data && data.files) || [];
    box.innerHTML = '';

    if (!files.length) {
      var empty = box.getAttribute('data-empty') || 'Nessun file disponibile al momento. Lo troverai qui non appena verrà caricato.';
      state(box, 'ei-bs-dl__state--empty', empty);
      if (data && data.folderUrl) {
        var a = el('a', 'ei-bs-dl__folder-link');
        a.href = data.folderUrl; a.target = '_blank'; a.rel = 'noopener';
        a.innerHTML = 'Apri la cartella su Drive ' + ICON_ARROW;
        box.appendChild(a);
      }
      return;
    }

    var list = el('div', 'ei-bs-dl__list');
    files.forEach(function (f) {
      var item = el('a', 'ei-bs-dl__item');
      item.href = f.url || '#';
      item.target = '_blank';
      item.rel = 'noopener';

      var ico = el('span', 'ei-bs-dl__ico', driveIcon(f.mimeType, f.isFolder));
      var txt = el('span', 'ei-bs-dl__txt');
      txt.appendChild(el('span', 'ei-bs-dl__name', escapeHtml(f.name || 'Senza nome')));
      var metaBits = [];
      if (f.isFolder) metaBits.push('Cartella');
      if (f.modified) metaBits.push('agg. ' + escapeHtml(f.modified));
      if (metaBits.length) txt.appendChild(el('span', 'ei-bs-dl__meta', metaBits.join(' · ')));
      var arrow = el('span', 'ei-bs-dl__arrow', ICON_ARROW);

      item.appendChild(ico);
      item.appendChild(txt);
      item.appendChild(arrow);
      list.appendChild(item);
    });
    box.appendChild(list);

    if (data && data.folderUrl) {
      var link = el('a', 'ei-bs-dl__folder-link');
      link.href = data.folderUrl; link.target = '_blank'; link.rel = 'noopener';
      link.innerHTML = 'Apri tutta la cartella su Drive ' + ICON_ARROW;
      box.appendChild(link);
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function load(box) {
    var sezione = box.getAttribute('data-sezione') || '';
    var folder = box.getAttribute('data-folder') || '';

    if (!API) {
      state(box, 'ei-bs-dl__state--config', 'Contenuti Drive in fase di configurazione. Saranno visibili qui a breve.');
      return;
    }
    if (!CLIENT && !EMAIL && !folder) {
      state(box, 'ei-bs-dl__state--config', 'Account non ancora collegato ai contenuti. Contatta il tuo referente.');
      return;
    }

    skeleton(box);

    var params = [];
    if (CLIENT) params.push('cliente=' + encodeURIComponent(CLIENT));
    if (EMAIL) params.push('email=' + encodeURIComponent(EMAIL));
    if (sezione) params.push('sezione=' + encodeURIComponent(sezione));
    if (folder) params.push('folder=' + encodeURIComponent(folder));

    var url = API + '/.netlify/functions/backstage-drive?' + params.join('&');

    fetch(url, { method: 'GET' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.ok === false) {
          state(box, 'ei-bs-dl__state--error', (d && d.error) || 'Non riesco a caricare i contenuti. Riprova tra poco.');
          return;
        }
        render(box, d);
      })
      .catch(function () {
        state(box, 'ei-bs-dl__state--error', 'Servizio non raggiungibile. Riprova tra poco.');
      });
  }

  function init() {
    var boxes = document.querySelectorAll('[data-ei-drive]');
    Array.prototype.forEach.call(boxes, load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
